import { useEffect, useRef, useState } from "react";
import NavBarLogo from "../images/NavBarLogo/NavBarLogo";
import {
  ProfileSearchbar,
  ProfileIcons,
  ProfileNavbarLogo,
  ProfileNavbarBackground,
  ProfilePicture,
  VerticleLine,
  NavIcon,
  LogoButton,
} from "./Navbar.styles";
import {
  MainMenu,
  AdvancedSettingsMenu,
  OrganizationsMenu,
} from "./SettingsDropDown";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import SettingsIcon from "@mui/icons-material/Settings";
import { useSelector } from "react-redux";
import { NotificationPanel } from "./NotificationsDropDown";
import { getNotifications } from "apis/MemoServiceApi";
import NavBarSearch from "./NavBarSearch/NavBarSearch";
import { SwitchAccountsMenu } from "./SettingsDropDown/SwitchAccountsMenu";

function Navbar() {
  const refIcon = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openAdvancedSettings, setOpenAdvancedSettings] = useState(false);
  const [openOrganizationMenu, setOpenOrganizationMenu] = useState(false);
  const [openSwitchAccounts, setOpenSwitchAccounts] = useState(false);
  const [openNotificationPanel, setOpenNotificationPanel] = useState(false);
  const [notificationPage, setNotificationPage] = useState(1);
  const [notificationList, setNotificationList] = useState<any>({
    notifications: [],
    total: 0,
    sum: 0,
  });
  console.log(openMenu, " openMenu");
  useEffect(() => {
    fetchNotifications();
  }, [notificationPage]);

  const handleLoadMore = async () => {
    setNotificationPage(notificationPage + 1);
  };

  const fetchNotifications = async () => {
    try {
      const response = await getNotifications(notificationPage);
      if (notificationList?.values?.length) {
        response.values = [...notificationList.values, ...response.values];
        response.sum = notificationList.sum + response.sum;
      }
      setNotificationList(response);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  function handleMenuClick() {
    setOpenMenu(!openMenu);
    setOpenNotificationPanel(false);
    setOpenAdvancedSettings(false);
    setOpenOrganizationMenu(false);
    setOpenSwitchAccounts(false);
  }

  function handleNotificationsClick() {
    setOpenNotificationPanel(!openNotificationPanel);
    setOpenMenu(false);
  }

  const userData = useSelector((state: any) => {
    return {
      profilePicture: state.user.socialAvatarUrl,
    };
  });
  return (
    <>
      <ProfileNavbarBackground>
        <ProfileNavbarLogo>
          <LogoButton to="/feed">
            <NavBarLogo />
          </LogoButton>

          <VerticleLine />

          <LogoButton to="/org/home">
            <ProfilePicture src={userData.profilePicture} />
          </LogoButton>
        </ProfileNavbarLogo>

        <ProfileSearchbar>
          <NavBarSearch />
        </ProfileSearchbar>
        {/* <ProfileIcons>
          {notificationList.total_unread > 0 ? (
            <NotificationImportantIcon
              style={{ color: "#FE2F67", cursor: "pointer" }}
              ref={refIcon}
              onClick={handleNotificationsClick}
            />
          ) : (
            <NotificationsNoneIcon
              style={{ color: "#FE2F67", cursor: "pointer" }}
              ref={refIcon}
              onClick={handleNotificationsClick}
            />
          )}
          <SettingsIcon
            style={{ color: "#FE2F67", cursor: "pointer" }}
            ref={refIcon}
            onClick={handleMenuClick}
          />
        </ProfileIcons>
         */}
        <ProfileIcons>
          <NavIcon
            aria-label="Notifications"
            onClick={handleNotificationsClick}
            ref={refIcon}
          >
            {notificationList.total_unread > 0 ? (
              <NotificationImportantIcon />
            ) : (
              <NotificationsNoneIcon />
            )}
          </NavIcon>

          <NavIcon
            aria-label="Settings"
            onClick={handleMenuClick}
            ref={refIcon}
          >
            <SettingsIcon />
          </NavIcon>
        </ProfileIcons>

        {openMenu && (
          <MainMenu
            setOpenMenu={setOpenMenu}
            openMenu={openMenu}
            setOpenAdvancedSettings={setOpenAdvancedSettings}
            openAdvancedSettings={openAdvancedSettings}
            openSwitchAccounts={openSwitchAccounts}
            setOpenSwitchAccounts={setOpenSwitchAccounts}
          />
        )}
        {openAdvancedSettings && (
          <AdvancedSettingsMenu
            setOpenOrganizationMenu={setOpenOrganizationMenu}
            openOrganizationMenu={openOrganizationMenu}
            setOpenAdvancedSettings={setOpenAdvancedSettings}
            openAdvancedSettings={openAdvancedSettings}
            setOpenMenu={setOpenMenu}
            openMenu={openMenu}
          />
        )}
        {openOrganizationMenu && (
          <OrganizationsMenu
            setOpenMenu={setOpenMenu}
            openMenu={openMenu}
            setOpenAdvancedSettings={setOpenAdvancedSettings}
            openAdvancedSettings={openAdvancedSettings}
            setOpenOrganizationMenu={setOpenOrganizationMenu}
            openOrganizationMenu={openOrganizationMenu}
          />
        )}
        {openSwitchAccounts && (
          <SwitchAccountsMenu
            openSwitchAccounts={openSwitchAccounts}
            setOpenSwitchAccounts={setOpenSwitchAccounts}
            setOpenMenu={setOpenMenu}
          />
        )}

        {openNotificationPanel && (
          <NotificationPanel
            openNotificationPanel={openNotificationPanel}
            setOpenNotificationPanel={setOpenNotificationPanel}
            notificationList={notificationList}
            setNotificationList={setNotificationList}
            notificationPage={notificationPage}
            setNotificationPage={setNotificationPage}
            handleLoadMore={handleLoadMore}
          />
        )}
      </ProfileNavbarBackground>
    </>
  );
}

export default Navbar;
